import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useOutletContext } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL, BASIC_AUTH } from "../constants";
import { notifyError, notifySuccess } from "../components/notify";
import Loader from "../components/Spinner/logoLoader";

const ProfileRow = ({ label, value }) => (
  <div className="col-md-6">
    <span className="profile-label">{label}</span>
    <p className="profile-value">{value || "-"}</p>
  </div>
);

const Profile = () => {
  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;

  const companyStr = localStorage.getItem("company");
  const company = companyStr ? JSON.parse(companyStr) : null;
  const { setPageTitle } = useOutletContext();
  const [updateModal, setUpdateModal] = useState(false);
  const [imageError, setImageError] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPageTitle("Profile");
  }, [setPageTitle]);

  const handleModalEntered = () => {
    setImageError("");
    setImageFile(null);
    setPreview(null);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImageFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleUpdateProfile = async () => {
    setLoading(true);
    setImageError("");

    if (!imageFile) {
      setImageError("Please Add Image");
      return;
    }

    try {
      const formData = new FormData();

      formData.append("companycode", company.companycode);
      formData.append("delivery_agent_code", user.delivery_agents_code);
      formData.append("delivery_image", imageFile);

      const res = await axios.post(
        `${API_BASE_URL}/delivery/update_delivery_agent_details`,
        formData,
        {
          headers: {
            Authorization: BASIC_AUTH,
          },
        }
      );

      if (res.data.success) {
        notifySuccess(
          res.data.message || "Delivery agent details update successfully"
        );
        setUpdateModal(false);
        handleAgentLogin();
      } else {
        notifyError(
          res.data.message || "Failed to upadet delivery agent details"
        );
      }
    } catch (error) {
      console.error("update agent details error:", error);

      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Failed to update delivery details. Please try again.";

      notifyError(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  const handleAgentLogin = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/delivery/delivery_agent_login`,
        {
          params: {
            MobileNo: user.mobile_no,
            Password: user.password,
          },
          headers: {
            Authorization: BASIC_AUTH,
          },
        }
      );

      localStorage.setItem("user", JSON.stringify(response.data.user));
      localStorage.setItem("company", JSON.stringify(response.data.company));
      //  RELOAD PAGE AFTER LOGIN SUCCESS
      window.location.reload();
    } catch (err) {
      console.error(err);
      notifyError("Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {loading && <Loader message="loading" />}
      <div className="container mt-2">
        <div className="card shadow-sm  profile-card">
          <div className=" profile-card-header d-flex">
            {/* User Image */}
            {user?.profile_pic && (
              <div className="text-start ">
                <img
                  src={user.profile_pic}
                  onClick={() => {
                    setUpdateModal(true);
                  }}
                  alt="User Logo"
                  className="profile-company-logo"
                  style={{ cursor: "pointer" }}
                  title="Edit User Details"
                />
              </div>
            )}
            <h5 className="mb-0 ms-3 mt-3 fw-bold text-dark">User </h5>
          </div>

          <div className="card-body ">
            <div className="row g-3">
              <ProfileRow label="Name" value={user.name} />
              <ProfileRow label="Email" value={user.email} />
              <ProfileRow label="Mobile No." value={user.mobile_no} />
              <ProfileRow label="Address" value={user.address} />
            </div>
          </div>
        </div>
        <div className="card shadow-sm  profile-card1">
          <div className=" profile-card-header d-flex">
            {/* Company Image */}
            {company?.cmp_image && (
              <div className="text-start ">
                <img
                  src={company.cmp_image}
                  alt="Company Logo"
                  className="profile-company-logo"
                />
              </div>
            )}
            <h5 className="mb-0 ms-3 mt-3 fw-bold text-dark">Company </h5>
          </div>

          <div className="card-body">
            <div className="row g-3">
              <ProfileRow label="Name" value={company.com_name} />
              <ProfileRow label="Short Name" value={company.com_name} />
              <ProfileRow label="Email" value={company.cmp_email} />
              <ProfileRow label="Whatsapp No." value={company.cmp_whatsapp} />
              <ProfileRow label="Mobile No." value={company.cmp_mobile} />
              <ProfileRow label="Address" value={company.address} />
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={updateModal}
        onHide={() => {
          setUpdateModal(false);
          setPreview(null);
          setImageFile(null);
        }}
        backdrop="static"
        keyboard={false}
        centered
        onEntered={handleModalEntered}
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton className="py-1">
            <Modal.Title className="d-block">
              <div className="text-theme">Edit Profile Image</div>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="d-flex gap-2">
              {/* Camera */}
              <input
                type="file"
                accept="image/*"
                capture="environment"
                id="cameraInput"
                hidden
                onChange={handleImageChange}
              />

              <button
                className="btn btn-outline-theme"
                onClick={() => document.getElementById("cameraInput").click()}
              >
                📷 Take Photo
              </button>

              {/* Gallery */}
              {/* <input
        type="file"
        accept="image/*"
        id="galleryInput"
        hidden
        onChange={handleImageChange}
      />

      <button
        className="btn btn-outline-theme"
        onClick={() =>
          document.getElementById("galleryInput").click()
        }
      >
        🖼️ Choose from Gallery
      </button> */}
            </div>
            {imageError && <p className="red-error">{imageError}</p>}

            {preview && (
              <div className="d-flex justify-content-center">
                <img
                  src={preview}
                  alt="Preview"
                  className="img-fluid mt-2 rounded "
                  style={{ maxHeight: "200px" }}
                />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="danger"
              onClick={() => {
                setUpdateModal(false);
                setPreview(null);
                setImageFile(null);
              }}
            >
              Cancel
            </Button>

            <Button variant="success" onClick={handleUpdateProfile}>
              Submit
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};
export default Profile;
